import { forwardRef, useEffect, useRef, useState } from "react"
import { CommonTransition } from "../utils/CommonTransition"
import { useIsInViewport } from "../utils/CustomHooks"
import { Link } from "react-router-dom"
import { Mission, Vision } from "./About"
import { Slider } from "../utils/Slider"
import { ASSETS_URL } from "../utils/constants"

const founderPic2 = ASSETS_URL + "founder-1.png"
const founderPic3 = ASSETS_URL + "founder-2.png"
const teamBaguio = ASSETS_URL + 'team_baguio.png'
const teamFairview = ASSETS_URL + 'team_fairview.png'
const teamRgbde = ASSETS_URL + 'team_rgbde.png'
const teamAdmin = ASSETS_URL + 'team_administration.png'
const teamEngineering = ASSETS_URL + 'team_designEngineering.png'
const teamFinance = ASSETS_URL + 'team_finance.png'

const Heading = forwardRef(({className,children}, ref) => <>
    <p ref={ref} className={`font-extrabold text-2xl my-5 ${className}`}> {children} </p>
</>)

const TextLeftParagraph = forwardRef(({className, children}, ref) => <>
  <p ref={ref} className={`my-3 w-full text-sm sm:text-base text-justify ${className}`}>{children}</p>
</>)

const YellowLink = ({to, className, children}) => <>
  <Link className={`hover:underline text-[#4CB117] ${className}`} to={to}>{children}</Link>
</> 

export function Team() {
    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)
    useEffect(() => {
        if(containerRef.current) {
          containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
        }
      }, [containerRef])
    return <>
        <div ref={containerRef} className="w-[80%] text-[#f7f7f7] text-left my-8 bg-[#212121] font-[Montserrat]">
            <Mission />
            <Vision />

            <CommonTransition open={isInViewport} durationEnter={'delay-[1000ms] duration-[1000ms]'} enterFrom={'translate-y-full text-[#4CB117]'} enterTo={'text-[#f7f7f7]'}>
                <div className="mt-10 mb-12">
                <TextLeftParagraph>At Total Solar Installation, we take pride in our commitment to innovation and cutting-edge technology. We stay at the forefront of the solar industry, consistently researching and implementing the latest advancements to offer our customers the most efficient and cost-effective solutions. We understand that every home, business, and community has unique energy needs. That's why we offer a wide range of <YellowLink to={'/projects'}>customizable solar solutions</YellowLink> to suit any requirement. Whether you are looking for a residential solar system to power your home or a commercial-scale installation for your business, we have the expertise to design, install, and maintain a solar energy system tailored specifically for your needs.</TextLeftParagraph> 
                <TextLeftParagraph>We believe in transparent communication and will ensure you have a full understanding of your solar energy system's benefits, performance, and long-term savings. By reducing your reliance on traditional power sources, you will not only significantly lower your electricity bills but also make a positive impact on the environment. Investing in solar energy is a smart financial decision that will pay dividends for years to come.</TextLeftParagraph>
                </div>
            </CommonTransition>
            
            <iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F100085341354458%2Fvideos%2F797465305155505%2F&show_text=false&width=560&t=0" className='aspect-video w-full border-0 overflow-hidden' allow="autoplay clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen={true} />

            <div className="mt-16">
                <AboutCEO />
            </div>
            

            <TeamsTitle />
            <TeamsBehind />
            
            <p className="mt-[20px] text-sm sm:text-base">Join us on our mission to create a cleaner, more sustainable future. Discover the power of solar energy with Total Solar Installation.</p>
            <p className="text-sm sm:text-base"><YellowLink to={'/contact'}>Contact us today!</YellowLink> </p> 

        </div>
    </>
}

const AboutCEO = () => {
    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)
    return <>
        <CommonTransition open={isInViewport} durationEnter={'duration-[500ms]'} enterFrom={'translate-y-full opacity-100 text-[#4CB117]'} enterTo={'text-[#f7f7f7]'}>
            <Heading>About our CEO</Heading>
        </CommonTransition>

        <div ref={containerRef} className="flex flex-col-reverse md:flex-row items-center md:items-start sm:mb-40 font-[Montserrat]">
            <div className="sm:pr-8">
                <CommonTransition open={isInViewport} durationEnter={'duration-[1000ms]'} enterFrom={'translate-y-full'}>
                    <TextLeftParagraph className={'mt-1'}>Engr. Ronmar B. Gonzales is a Solar PV Consultant specializing in Electrical and Plumbing design. He is a Professional Electrical Engineer (Reg. No. 4417), a registered Master Plumber (Reg. No. 8507), a Mechanical Engineer, and a Certified Energy Manager. </TextLeftParagraph>
                </CommonTransition>
                <CommonTransition open={isInViewport} durationEnter={'duration-[1500ms]'} enterFrom={'translate-y-full'}>
                    <div>
                    <TextLeftParagraph>He has 14 years of experience in Electrical Design, Construction, and Operation of high-rise commercial, residential, and ship establishments.</TextLeftParagraph>
                    </div>
                    
                </CommonTransition>

                <div className="flex flex-col sm:flex-row justify-start w-full items-center">
                    
                    <CommonTransition open={isInViewport} durationEnter={'duration-[2000ms]'} enterFrom={'translate-y-[50%]'}>
                        <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" src={founderPic3} className="object-cover h-[300px] w-[300px]"/>
                    </CommonTransition>

                    <CommonTransition open={isInViewport} durationEnter={'duration-[1500ms]'} enterFrom={'translate-y-full'}>
                        <div className="sm:ml-10">
                            <TextLeftParagraph>He is also an active member of Institute of Integrated Electrical Engineers of the Philippines, Inc. (IIEE) Cebu Chapter and was once as Secretary, Technical Speaker and PEE Mentor. He’s the newly elected President of IIEE - Cebu Chapter for year 2024.</TextLeftParagraph>
                        </div>
                        
                    </CommonTransition>
                
                </div>
                
            </div>
            
            <CommonTransition open={isInViewport} durationEnter={'duration-[2000ms]'} enterFrom={'translate-x-[50%]'}>
                <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" src={founderPic2} className="object-cover h-[250px] w-[250px] sm:h-[350px] sm:w-[350px]"/>
            </CommonTransition>
        </div>
    </>
}
const TextOnHoverImg = ({text, children}) => {
    const [isHovered, setIsHovered] = useState(false);

    return <div className="relative w-full" onMouseEnter={()=>setIsHovered(true)} onMouseLeave={()=>setIsHovered(false)} >
        {children}

        <CommonTransition open={isHovered} durationEnter={'duration-[1500ms]'} durationExit={'duration-[1500ms]'}>
        <div className="absolute bottom-4 left-0 w-full bg-[#f7f7f7] text-[#000000] text-center">{text}</div>
        </CommonTransition>
        
    </div>
}
const TeamsBehind = () => {
    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)

    return <>
    <div ref={containerRef}>
    <CommonTransition open={isInViewport} durationEnter={'duration-[5000ms]'}>
        <div>

        <ImageGallery />
        </div>
    </CommonTransition>
    </div>
    </>

}

const TeamsTitle=() =>{
    const containerRef = useRef(null)
    const isInViewport = useIsInViewport(containerRef)

    return<>
    <div ref={containerRef} className="flex flex-col sm:flex-row items-center font-[Montserrat] ">
    <CommonTransition open={isInViewport} durationEnter={'duration-[1500ms]'} enterFrom={'opacity-100'} enterTo={'text-[#4CB117]'}>

    <div className="h-[100%]">
            <Heading className={'text-[120px] sm:text-[150px] leading-none font-[Montserrat] text-justify'}>T E<br/>AM</Heading>
            <Heading className={'text-[120px] sm:text-[150px] leading-none font-[Montserrat] h-auto'}></Heading>
    </div>
    </CommonTransition>

    <CommonTransition open={isInViewport} durationEnter={'duration-[1500ms]'} enterFrom={'opacity-100 text-[#4CB117]'} enterTo={'text-[#f7f7f7]'}>

    <div className="sm:ml-[20px] mb-5">
        <p className="font-bold">The Teams Behind Total Solar</p>
        <p className="text-justify text-sm sm:text-base">Beyond providing exceptional solar solutions, we are dedicated to educating and empowering our customers. Our different teams of solar experts are here to guide you through the entire process, from initial consultation, to solar panel installations, and to system monitoring and maintenance.</p>
    </div>
    </CommonTransition>

    </div>
    </>
}

const ImageGallery = () =>{
    const sliderConfig = {
        all: {
            enableAutoplay: true,
            autoplayInterval: 3000,
            transitionDuration: 200,
            slidesToShow: 1,
        },
      }
    return <>
    <div className="hidden sm:block container mx-auto w-[70%]">
        <div className="-m-1 flex flex-wrap md:-m-2">
            <div className="flex w-1/2 flex-wrap">
                <div className="w-full p-1 md:p-2">
                    <TextOnHoverImg text={'Installation Team - Baguio City'}>
                    <img
                    alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                    className="block h-full w-full object-cover object-center"
                    src={teamBaguio} />
                    </TextOnHoverImg>
                </div>

                <div className="w-full p-1 md:p-2">
                <TextOnHoverImg text={'Administration Team'}>
                    <img
                    alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                    className="block h-full w-full object-cover object-center"
                    src={teamAdmin}  />
                </TextOnHoverImg>
                </div>
            </div>
            
            <div className="flex w-1/2 flex-wrap">
                <div className="w-full p-1 md:p-2">
                    <TextOnHoverImg text={'RB Gonzales Design and Engineering Team'}>
                        <img
                        alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                        className="block h-full w-full object-cover object-center"
                        src={teamRgbde}  />
                    </TextOnHoverImg>
                </div>
                <div className="w-full p-1 md:p-2">
                    <TextOnHoverImg text={'Installation Team - Fairview'}>
                        <img
                        alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                        className="block h-full w-full object-cover object-center"
                        src={teamFairview}  />
                    </TextOnHoverImg>
                </div>
            </div>

            <div className="flex w-1/2 flex-wrap">
                <div className="w-full p-1 md:p-2">
                    <TextOnHoverImg text={'Design and Engineering Team'}>
                        <img
                        alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                        className="block h-full w-full object-cover object-center"
                        src={teamEngineering}  />
                    </TextOnHoverImg>
                </div>
            </div>
            <div className="flex w-1/2 flex-wrap">
                <div className="w-full p-1 md:p-2">
                    <TextOnHoverImg text={'Finance Manager'}>
                        <img
                        alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                        className="block h-full w-full object-cover object-center"
                        src={teamFinance}  />
                    </TextOnHoverImg>
                </div>
            </div>
        </div>
    </div>
    <div className="block sm:hidden">
        <Slider config={sliderConfig}>
            <TextOnHoverImg text={'Installation Team - Baguio City'}>
                <img
                alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                className="block h-full w-full object-cover object-center"
                src={teamBaguio} />
            </TextOnHoverImg>
            <TextOnHoverImg text={'Administration Team'}>
                <img
                alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                className="block h-full w-full object-cover object-center"
                src={teamAdmin}  />
            </TextOnHoverImg>
            <TextOnHoverImg text={'RB Gonzales Design and Engineering Team'}>
                <img
                alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                className="block h-full w-full object-cover object-center"
                src={teamRgbde}  />
            </TextOnHoverImg>
            <TextOnHoverImg text={'Installation Team - Fairview'}>
                <img
                alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                className="block h-full w-full object-cover object-center"
                src={teamFairview}  />
            </TextOnHoverImg>
            <TextOnHoverImg text={'Design and Engineering Team'}>
                <img
                alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                className="block h-full w-full object-cover object-center"
                src={teamEngineering}  />
            </TextOnHoverImg>
            <TextOnHoverImg text={'Design and Engineering Team'}>
                <img
                alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" 
                className="block h-full w-full object-cover object-center"
                src={teamFinance}  />
            </TextOnHoverImg>
        </Slider>

    </div>
    </>
}